import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CANDIDATES_ROUTES } from './candidates.routes';

const routes: Routes = [...CANDIDATES_ROUTES];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CandidatesRoutingModule {}
